function getCapacitor() {
  if (typeof window === "undefined") return null;
  const capacitor = window.Capacitor;
  if (!capacitor || typeof capacitor !== "object") return null;
  return capacitor;
}

function getCapacitorPlugin(name) {
  const capacitor = getCapacitor();
  if (!capacitor) return null;

  if (capacitor.Plugins && capacitor.Plugins[name]) {
    return capacitor.Plugins[name];
  }

  if (typeof capacitor.registerPlugin === "function") {
    try {
      return capacitor.registerPlugin(name);
    } catch (_error) {
      return null;
    }
  }

  return null;
}

export function isCapacitorNativeRuntime() {
  if (typeof window === "undefined") return false;
  if (document.documentElement?.dataset?.nativeRuntime === "true") return true;

  const protocol = window.location?.protocol;
  if (protocol === "capacitor:" || protocol === "ionic:") return true;

  if (/\bCapacitor\b/i.test(window.navigator?.userAgent || "")) return true;

  const capacitor = getCapacitor();
  if (!capacitor) return false;

  if (typeof capacitor.isNativePlatform === "function") {
    try {
      return Boolean(capacitor.isNativePlatform());
    } catch (_error) {
      // fall through to other checks
    }
  }

  if (typeof capacitor.getPlatform === "function") {
    try {
      return capacitor.getPlatform() !== "web";
    } catch (_error) {
      // fall through to other checks
    }
  }

  return capacitor.platform === "ios" || capacitor.platform === "android";
}

export const Directory = {
  Documents: "DOCUMENTS",
  Data: "DATA",
  Cache: "CACHE"
};

function safeFilenameFromUrl(url, fallback = "download") {
  try {
    const parsed = new URL(url, window.location.origin);
    const leaf = parsed.pathname.split("/").filter(Boolean).pop() || fallback;
    return leaf.includes(".") ? leaf : fallback;
  } catch (_error) {
    return fallback;
  }
}

export async function downloadAndShareUrl({ url, filename, directory = Directory.Documents } = {}) {
  if (!url) throw new Error("downloadAndShareUrl: missing url");

  const Filesystem = getCapacitorPlugin("Filesystem");
  const FileTransfer = getCapacitorPlugin("FileTransfer");
  const Share = getCapacitorPlugin("Share");

  if (!Filesystem || !FileTransfer || !Share) {
    throw new Error("Missing Capacitor plugin: Filesystem, FileTransfer, or Share");
  }

  const path = filename || safeFilenameFromUrl(url, "catch-photo.jpg");
  const fileInfo = await Filesystem.getUri({ directory, path });

  // WKWebView can be unreliable for `<a download>` and `blob:` URLs.
  // Native transfer + filesystem avoids large in-memory blobs in JS.
  await FileTransfer.downloadFile({
    url,
    path: fileInfo.uri,
    progress: false
  });

  await Share.share({
    title: "ImOnImOn",
    url: fileInfo.uri
  });

  return fileInfo.uri;
}

export async function openExternalUrl(url) {
  if (!url) return;

  const Browser = getCapacitorPlugin("Browser");
  if (Browser && typeof Browser.open === "function") {
    await Browser.open({ url });
    return;
  }

  window.open(url, "_blank", "noopener,noreferrer");
}

export async function shareTextAndUrl({ title = "ImOnImOn", text = "", url = "" } = {}) {
  const Share = getCapacitorPlugin("Share");
  if (Share && typeof Share.share === "function") {
    await Share.share({ title, text, url });
    return true;
  }

  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    await navigator.share({ title, text, url });
    return true;
  }

  return false;
}
